import { render, staticRenderFns } from "./ConfirmBuyPoint.vue?vue&type=template&id=61484f7e&scoped=true&"
import script from "./ConfirmBuyPoint.vue?vue&type=script&lang=js&"
export * from "./ConfirmBuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBuyPoint.vue?vue&type=style&index=0&id=61484f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61484f7e",
  null
  
)

export default component.exports